import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [TranslateModule],
  declarations: [ModalComponent],
  exports: [ModalComponent],
})
export class ModalModule {}
